import axios, { type AxiosRequestConfig } from 'axios';
import { config, createHeaders } from '.';
import { LoadSerialNumbersParams, LoadSerialNumbersResponse } from '../models/serial-numbers';

export const loadSerialNumbers = async (
  accessToken: string,
  params: LoadSerialNumbersParams
) => {
  const { 
    companyId, 
    limitResult, 
    lastSerialNumber, 
    lastId, 
    searchTerm 
  } = params;

  let url = `serialNumbers/${companyId}`;
  
  const queryParams: Record<string, string> = {};

  if (limitResult) {
    queryParams.limitResult = String(limitResult);
  };
  if (searchTerm) {
    queryParams.searchTerm = searchTerm;
  };
  
  if (lastSerialNumber) {
    queryParams.lastSerialNumber = lastSerialNumber;
  };
  if (lastId) {
    queryParams.lastId = String(lastId);
  };

  const queryString = new URLSearchParams(queryParams).toString();
  if (queryString) {
    url += `?${queryString}`;
  };

  const localConfig: AxiosRequestConfig = {
    ...config,
    url,
    method: 'get',
    headers: createHeaders({ accessToken })
  };
  
  return axios.request<LoadSerialNumbersResponse>(localConfig);
};

export const createSerialNumbers = async (content: any, accessToken: string) => {
  const localConfig: AxiosRequestConfig = {
    ...config,
    url: 'serialNumbers',
    method: 'post',
    data: content,
    headers: createHeaders({ accessToken }),
  };
  
  return axios.request<any>(localConfig);
};

export const updateSerialNumbers = async (id: number, content: any, accessToken: string) => {
  const localConfig: AxiosRequestConfig = {
    ...config,
    url: `serialNumbers/${id}`,
    method: 'put',
    data: content,
    headers: createHeaders({ accessToken })
  };
  
  return axios.request<any>(localConfig);
};

export const deleteSerialNumbers = async (content: any, accessToken: string) => {
  const localConfig: AxiosRequestConfig = {
    ...config,
    url: 'serialNumbers',
    method: 'delete',
    data: content,
    headers: createHeaders({ accessToken })
  };
  
  return axios.request<any>(localConfig);
};